/** Project ref from Supabase URL, e.g. https://abc.supabase.co → abc */
export function supabaseProjectRefFromUrl(supabaseUrl: string): string {
  try {
    return new URL(supabaseUrl).hostname.split('.')[0] ?? ''
  } catch {
    return supabaseUrl.split('//')[1]?.split('.')[0] ?? ''
  }
}

/** Paused Applicator project — must never be used after migration. */
export const LEGACY_SUPABASE_PROJECT_REF = 'rsrshrvshmurohmgezva'

/** Remove auth tokens from paused/other Supabase projects (migration rsrshrv → dhlzam). */
export function clearStaleSupabaseAuthStorage(currentProjectRef: string): void {
  if (typeof window === 'undefined' || !currentProjectRef) return
  const prefix = 'sb-'
  const suffix = '-auth-token'
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i)
    if (!key?.startsWith(prefix) || !key.endsWith(suffix)) continue
    const ref = key.slice(prefix.length, -suffix.length)
    if (ref !== currentProjectRef) {
      localStorage.removeItem(key)
    }
  }
}

/**
 * Drop legacy paused-project Supabase keys only (by key name).
 * Do not scan arbitrary localStorage values — JWT/session JSON can false-match substrings.
 */
export function clearLegacySupabaseHostArtifacts(currentProjectRef?: string): void {
  if (typeof window === 'undefined') return
  const legacy = LEGACY_SUPABASE_PROJECT_REF
  const prefix = 'sb-'

  for (const store of [localStorage, sessionStorage]) {
    for (let i = store.length - 1; i >= 0; i--) {
      const key = store.key(i)
      if (!key) continue

      if (key.startsWith(`${prefix}${legacy}-`)) {
        store.removeItem(key)
        continue
      }

      if (currentProjectRef && key.startsWith(`${prefix}${currentProjectRef}-`)) {
        continue
      }

      if (key.startsWith(prefix) && key.includes(legacy)) {
        store.removeItem(key)
        continue
      }

      if (!key.startsWith(prefix) && key.includes(legacy)) {
        store.removeItem(key)
      }
    }
  }
}

export function assertSupabaseUrlMatchesEnv(url: string): void {
  if (!url.includes('dhlzamcevaakpmpmwsij')) {
    throw new Error(
      'Неверный VITE_SUPABASE_URL: ожидается проект dhlzamcevaakpmpmwsij. ' +
        'Перезапусти dev (npm run dev:no-ngrok) и сделай жёсткое обновление страницы (Cmd+Shift+R).'
    )
  }
  if (url.includes(LEGACY_SUPABASE_PROJECT_REF)) {
    throw new Error(
      'В конфиге остался старый Supabase (rsrshrv). Обнови packages/web/.env.local и перезапусти Vite.'
    )
  }
}
